<div contenteditable="true" #htmlData class="form-control app-custom-taginput" [id]="id"
    [ngClass]="{'is-valid': stateForm === true, 'is-invalid' : stateForm === false }" (keyup)="onKey($event)">
</div>